import { ReactElement } from "react";

import { Text } from "@meditect/medibase-components";

export const OrderNotFoundForClose = (): ReactElement => {
  return <Text>Vous ne pouvez pas cloturer cette préparation de commande.</Text>;
};
